import React from 'react'

export function CardPaymentIcon({color = '#ffffff'}) {
  return (
    <svg
      width="18"
      height="14"
      viewBox="0 0 18 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{display: 'block'}}
    >
      <path
        d="M14.25 0H3.75C2.7558 0.00119089 1.80267 0.396661 1.09966 1.09966C0.396661 1.80267 0.00119089 2.7558 0 3.75L0 9.75C0.00119089 10.7442 0.396661 11.6973 1.09966 12.4003C1.80267 13.1033 2.7558 13.4988 3.75 13.5H14.25C15.2442 13.4988 16.1973 13.1033 16.9003 12.4003C17.6033 11.6973 17.9988 10.7442 18 9.75V3.75C17.9988 2.7558 17.6033 1.80267 16.9003 1.09966C16.1973 0.396661 15.2442 0.00119089 14.25 0ZM3.75 1.5H14.25C14.8467 1.5 15.419 1.73705 15.841 2.15901C16.2629 2.58097 16.5 3.15326 16.5 3.75H1.5C1.5 3.15326 1.73705 2.58097 2.15901 2.15901C2.58097 1.73705 3.15326 1.5 3.75 1.5ZM14.25 12H3.75C3.15326 12 2.58097 11.7629 2.15901 11.341C1.73705 10.919 1.5 10.3467 1.5 9.75V5.25H16.5V9.75C16.5 10.3467 16.2629 10.919 15.841 11.341C15.419 11.7629 14.8467 12 14.25 12Z"
        fill={color}
      />
    </svg>
  )
}
